import { CONTRACT_TYPE } from '@spa/shared/constants/contractType';

export const getMoveInOutByOptionId = (optionId, offerAggregate) => {
  const contract = offerAggregate.accommodation_offer.contract;
  const { fixed, fixed_unitary: fixedUnitary, type } = contract;

  if (![CONTRACT_TYPE.FIXED, CONTRACT_TYPE.FIXED_UNITARY].includes(type)) {
    throw new Error('Wrong contract type');
  }

  const { options } = CONTRACT_TYPE.FIXED === type ? fixed : fixedUnitary;
  const { start_date: moveIn, end_date: moveOut } = options.find(({ id }) => id === optionId);

  return { moveIn, moveOut };
};
